import { all, takeEvery, put, fork } from "redux-saga/effects";
import { push } from "react-router-redux";

import * as actionTypes from "../actions/actionTypes";
import * as actions from "../actions/index";
import * as API from "../api";

export function* getShopIDbyTableQR() {
  yield takeEvery(actionTypes.GET_SHOP_ID_BY_TABLEQR, function*(action) {
    yield put(actions.enableLoading());
    try {
      const response = yield API.getShopIDbyTableQR(action.data);

      if (response.data.success && response.data.data) {
        yield put(actions.getShopIDByTableQRSuccess());
        yield put(push(`/restaurant/${response.data.data}/menu`));
      } else {
        alert(response.data.message);
        yield put(actions.getShopIDByTableQRFail());
      }
      yield put(actions.disableLoading());
    } catch (error) {
      yield put(actions.handleAPIError(error));
      yield put(actions.getShopIDByTableQRFail());
      yield put(actions.disableLoading());
    }
  });
}

export default function* tableSaga() {
  yield all([fork(getShopIDbyTableQR)]);
}
